import Vue from 'vue';
import Vuex from 'vuex';
import actions from '@/app/store/root/actions';
import mutations from '@/app/store/root/mutations';
import state from '@/app/store/root/state';

import authModule from './modules/auth/authModule';
import sidebarModule from './modules/sidebar/sidebarModule';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters: {
    languageList: data => data.languageList,
    currentLang: data => data.currentLang,
    recaptcha: data => data.reCaptcha,
    license: data => data.license,
    logoUrl: data => data.licenseImages.value,
    loading: data => data.loading,
    canRegister: data => Boolean(data.userSettings.value),
  },
  modules: {
    authModule,
    sidebarModule,
  },
});
